const SIGNUP_SCREENS: Record<string, string> = {
  "/": "landing",
  "/onboarding": "onboarding",
  "/download": "download",
};

export interface ResolvedScreen {
  screen: string;
  pagePath: string;
}

export function screenForPath(pathname: string): ResolvedScreen | null {
  const screen = SIGNUP_SCREENS[pathname];
  if (!screen) return null;
  return { screen, pagePath: pathname };
}
